//Loadable插件需使用Loading
import Loadable from 'react-loadable'
import Loading from '../components/Loading/index';

export const routerRoot = [
   
    {
        title: "办事大厅首页",
        path: "/",
        name: Loadable({
            loader: () => import('../views/Home'),
            loading: Loading
        })
    },
    {
        title: "外链二级列表",
        path: "/HomeList/:typename/:id?",
        name: Loadable({
            loader: () => import('../views/HomeList'),
            loading: Loading
        })
    },
    {
        title: "新闻列表",
        path: "/newsList/:typename",
        name: Loadable({
            loader: () => import('../views/List'),
            loading: Loading
        })
    },
    {
        title: "搜索列表",
        path: "/newsList/:typename/:search",
        name: Loadable({
            loader: () => import('../views/ListSearch'),
            loading: Loading
        })
    },
    {
        title: "新闻详情",
        path: "/newsDetail/:typename/:id",
        name: Loadable({
            loader: () => import('../views/Detail'),
            loading: Loading
        })
    },
 
];
